export default {
  manningVesselCategoryList: [],
  countryCodeList: [],
};
